import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=908e7c2c&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"
import style0 from "./navigation.sass?vue&type=style&index=0&id=908e7c2c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908e7c2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VToolbar})
